import { getAllUserIds } from "./user";
import {
    getMetrics,
    getUsage,
    getCompleteness,
    getCompletenessPercentageByBook
} from "../service/service";

/**
 * Tries a progress API call with each user ID until one succeeds.
 * Returns the first successful response. If all fail, throws the last error.
 * 
 * @param {Function} apiFn - receives (userId, ...rest) and returns a promise
 * @param {Array} restArgs - remaining arguments after userId
 */
async function tryWithAllIds(apiFn, restArgs) {
    var ids = await getAllUserIds();
    if (!ids || ids.length === 0) {
        throw { status: 404, message: "No user IDs available" };
    }

    var lastError = null;
    for (var i = 0; i < ids.length; i++) {
        try {
            var result = await apiFn(ids[i], restArgs);
            return result;
        } catch (err) {
            lastError = err;
            var status = err && err.response && err.response.status;
            // Only retry with next ID if 404 (not found for this user)
            if (status !== 404) {
                throw err;
            }
        }
    }
    throw lastError;
}

/**
 * getMetrics with fallback: tries IES id, then Sponte id
 */
export function getMetricsWithFallback(userId, exerciseId, tenant) {
    return tryWithAllIds(
        function (uid) { return getMetrics(uid, exerciseId, tenant); },
        []
    );
}

/**
 * getUsage with fallback: tries IES id, then Sponte id
 */
export function getUsageWithFallback(userId, lessonId, tenant) {
    return tryWithAllIds(
        function (uid) { return getUsage(uid, lessonId, tenant); },
        []
    );
}

/**
 * getCompleteness with fallback: tries IES id, then Sponte id
 */
export function getCompletenessWithFallback(userId, batchId, tenant) {
    return tryWithAllIds(
        function (uid) { return getCompleteness(uid, batchId, tenant); },
        []
    );
}

/**
 * getCompletenessPercentageByBook with fallback: tries IES id, then Sponte id
 */
export function getCompletenessPercentageByBookWithFallback(tenant, userId, bookId, totalLessonsCount) {
    return tryWithAllIds(
        function (uid) { return getCompletenessPercentageByBook(tenant, uid, bookId, totalLessonsCount); },
        []
    );
}
